// ─────────────────────────────────────────────────────────────────────────
// 수업 게이트 — "이 사람이 무엇까지 볼 수 있나"를 한 곳에서 답한다.
//
// 왜 훅으로 빼나: Day 로 들어가는 문이 하나가 아니다.
//   · 매트릭스의 Day 카드
//   · Day 를 끝내고 나오는 "다음 Day 하기"
//   · 학습 화면 안의 Day 네비게이터
// 문마다 판정을 따로 쓰면 하나는 반드시 빠지고, 빠진 문 하나로 게이트 전체가 무의미해진다.
// 판정 함수(pickedDaysOf)를 공유해서 세 문이 같은 답을 하게 한다(규칙 1).
//
// 규칙 3: 계획을 **못 읽었으면 잠그지 않는다.** 통신 실패로 학생을 가두는 것이
//   잘못 열어주는 것보다 나쁘다 — 자료가 통째로 사라진 것처럼 보인다.
// ─────────────────────────────────────────────────────────────────────────
import { useEffect, useState } from 'react';
import { getLicenseInfo } from '../utils/licenseService';
import { GATE, gateFor, pickedDaysOf } from '../lib/lessonPlan';
import { watchLessonPlan } from '../lib/lessonPlanStore';

export default function useLessonGate() {
  const [license] = useState(() => (typeof window === 'undefined' ? null : getLicenseInfo()));
  const gate = gateFor(license);
  const classId = license?.cohortId || null;
  // undefined = 아직 안 읽음 / null = 못 읽음 / 객체 = 읽음
  const [plan, setPlan] = useState(undefined);

  useEffect(() => {
    if (gate !== GATE.gated) return undefined;   // 게이트가 없으면 읽을 이유도 없다
    if (!classId) { setPlan(null); return undefined; }
    return watchLessonPlan(classId, setPlan);
  }, [gate, classId]);

  /**
   * 이 코스에서 열어도 되는 Day 번호들. **null 이면 제한 없음**(개인·강의자·게이트 없는 반,
   * 그리고 계획을 못 읽은 경우). 빈 배열은 "하나도 안 열림"이라 null 과 뜻이 다르다.
   */
  const allowedDays = (courseId) => {
    if (gate !== GATE.gated || !courseId) return null;
    if (plan === undefined || plan === null) return null;
    return pickedDaysOf(plan, courseId);
  };

  return { gate, plan, license, classId, allowedDays };
}
